import { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import SweetAlert from 'react-bootstrap-sweetalert';

const useUnsavedChanges = (isDirty) => {
  const history = useHistory();
  const [showLeavePrompt, setShowLeavePrompt] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);
  const unblockRef = useRef(null);

  useEffect(() => {
    if (!isDirty) return;
    unblockRef.current = history.block((location) => {
      setPendingLocation(location.pathname + location.search);
      setShowLeavePrompt(true);
      return false;
    });
    return () => { if (unblockRef.current) unblockRef.current(); };
  }, [isDirty, history]);

  const confirmLeave = () => {
    if (unblockRef.current) { unblockRef.current(); unblockRef.current = null; }
    setShowLeavePrompt(false);
    history.push(pendingLocation);
  };

  const cancelLeave = () => {
    setShowLeavePrompt(false);
    setPendingLocation(null);
  };

  const leavePrompt = showLeavePrompt ? (
    <SweetAlert
      warning
      title="Unsaved changes"
      confirmBtnText="Discard changes"
      onConfirm={confirmLeave}
      showCancel
      cancelBtnText="Cancel"
      cancelBtnBsStyle="secondary"
      onCancel={cancelLeave}
    >
      You have unsaved changes that will be lost if you navigate away.
    </SweetAlert>
  ) : null;

  return { unblockRef, leavePrompt };
};

export default useUnsavedChanges;
